export enum SpaceframeAppearance {
    Antares,
    ClassJCargoShip,
    Freighter,
    JovisType,
    Merchantman,
    XhosaType,
    KaplanF17PatrolFrigate,
    ConestogaType,

    // Romulan
    Aelahl,
    BirdOfPrey22ndCentury,
    Tliss,
    RomulanD7,
    Whitewind,
    DDeridex,
    Mogai,
    RedLadyType,
    Snakehead,
    ScimitarType,
    Khnial,


    // Orion
    DVar,
    Intruder,

    // Discovery-era Federation ships
    Kirk,
    Janeway,
    Friendship,
    Eisenberg
}